import { put, call, all, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/irrf'
import {
  getCustomerAccounts,
  getIrrfReport as getReport,
  getIrrfDownload as getDownload
} from 'services'

import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { IRRF, REQUEST_ERROR } from 'config/messages'

const {
  IRRF_REQUEST,
  IRRF_SUCCESS,
  IRRF_ERROR,
  IRRF_REPORT_REQUEST,
  IRRF_REPORT_SUCCESS,
  IRRF_REPORT_ERROR,
  IRRF_DOWNLOAD_REQUEST,
  IRRF_DOWNLOAD_SUCCESS,
  IRRF_DOWNLOAD_ERROR
} = ACTION_TYPES

export function *getIrrf() {
  try {
    const response = yield call(getCustomerAccounts)
    yield put({ type: IRRF_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: IRRF_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getIrrfReport(payload) {
  try {
    const response = yield call(getReport, payload)
    if (response.status === 200) {
      yield put({ type: IRRF_REPORT_SUCCESS, payload: response.data.value.incomeTaxes })
    } else if (response.status === 204) {
      yield put({ type: IRRF_REPORT_ERROR, payload: response })
      yield put({
        type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
        payload: { text: IRRF.NO_RESULTS_ERROR, type: 'error' }
      })
    }
  } catch (err) {
    yield put({ type: IRRF_REPORT_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export function *getIrrfDownload(payload) {
  try {
    let format
    let fileName
    switch (payload.payload.fileType) {
      case 'pdf':
        format = 'application/pdf'
        fileName = `ImpostoDeRenda${payload.payload.endDate}.pdf`
        break
      default:
        format = 'text/x-csv'
        fileName = `ImpostoDeRenda${payload.payload.endDate}.csv`
    }
    const response = yield call(getDownload, payload)
    yield put({ type: IRRF_DOWNLOAD_SUCCESS, payload: { response, format, fileName } })
  } catch (err) {
    yield put({ type: IRRF_DOWNLOAD_ERROR, payload: err })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export default function *watchIrrf() {
  yield all([
    takeLatest(IRRF_REQUEST, getIrrf),
    takeLatest(IRRF_REPORT_REQUEST, getIrrfReport),
    takeLatest(IRRF_DOWNLOAD_REQUEST, getIrrfDownload)
  ])
}
